import clsx from 'clsx'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { PATH } from 'utils/constants'
import { IMissionInfo } from 'utils/interfaces'

import style from './MissionsList.module.css'

const MissionModalItem = ({
  mission,
  selected,
  onSelect,
}: {
  mission: IMissionInfo
  selected: boolean
  onSelect: () => void
}) => {
  const { t } = useTranslation()

  return (
    <div className={selected ? clsx(style.tableItem, style.selected) : style.tableItem} onClick={onSelect}>
      <span className={style.missionId}>{mission.id}</span>
      <span className={style.missionName}>{mission.name}</span>
      <a className={style.link} href={`${PATH.MISSION}${mission.id}`} target="_blank" rel="noreferrer">
        {t('common.show')}
      </a>
    </div>
  )
}

const MissionsList = ({
  missions,
  selectedMission,
  onSelect,
  onScrollBottom,
}: {
  missions: IMissionInfo[]
  selectedMission: IMissionInfo | undefined
  onSelect: (mission: IMissionInfo) => void
  onScrollBottom?: () => void
}) => {
  const { t } = useTranslation()

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      onScrollBottom?.()
    }
  }

  return (
    <>
      <div className={style.table} onScroll={handleScroll}>
        <div className={style.tableHeader}>
          <span>{t('missions.id')}</span>
          <span>{t('missions.name')}</span>
          <span>{'Link'}</span>
        </div>
        {missions.map(mission => (
          <MissionModalItem
            key={mission.id}
            mission={mission}
            selected={mission?.id === selectedMission?.id}
            onSelect={() => onSelect(mission)}
          />
        ))}
      </div>
    </>
  )
}

export default MissionsList
